import React from "react";
import { CircleAlert, SearchX } from "lucide-react";

export default function SelectionFeedback({
  loading,
  error,
  title,
  description,
}) {
  if (loading) {
    return (
      <div
        className="op-selection-loading"
        role="status"
        aria-label="Loading choices"
      >
        {[0, 1, 2].map((item) => (
          <div key={item} className="op-choice-skeleton">
            <span />
            <div>
              <span />
              <span />
            </div>
          </div>
        ))}
      </div>
    );
  }
  const Icon = error ? CircleAlert : SearchX;
  return (
    <div className="op-empty-state" role={error ? "alert" : "status"}>
      <span className="op-icon">
        <Icon aria-hidden="true" />
      </span>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}
